<template>
  <com-page>
    <com-card>
      <dateSelect @on-date="handleData" @on-export="handleExport"></dateSelect>
    </com-card>
    <com-card class="mt-15px">
      <com-table ref="table" :columns="columns" :api="api"></com-table>
    </com-card>
  </com-page>
</template>

<script>
import { exportExcel } from '@/utils'
import { monthCardOrderStatistics } from '@/api/statistics'
import dateSelect from './components/the-time-select'

export default {
  components: { dateSelect },
  data() {
    return {
      api: monthCardOrderStatistics,
      columns: [
        {
          label: '日期',
          prop: 'date'
        },
        {
          label: '订单数',
          prop: 'monthCardOrder'
        },
        {
          label: '订单金额',
          prop: 'monthCardAmount'
        }
      ],
      query: {}
    }
  },
  methods: {
    handleData(val) {
      this.query = val
      this.$refs.table.search(val)
    },
    async handleExport() {
      try {
        this.$message.info('正在导出请稍后')
        const query = {
          ...this.query,
          pageIndex: 1,
          pageSize: 10000
        }
        const {
          data: { records }
        } = await monthCardOrderStatistics(query)
        console.log('data :>> ', records)
        const newArr = []
        records.forEach((item) => {
          const param = {
            日期: item.date,
            订单数: item.monthCardOrder,
            订单金额: item.monthCardAmount
          }
          newArr.push(param)
        })
        exportExcel(newArr, '月卡订单分析')
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
